import { useCallback, useContext } from 'react';
import { httpWithAuth } from '~/clients';
import { GET_DELIVERY_PICKUP } from '~/constants/endpoints';
import StaticContext from '~/context/common/StaticContext';
import { useUserLocation } from '~/context/common/UserContext';
import BulkAvailabilityPayload from '~/contracts/common/BulkAvailabilityPayload';
import { DeliveryPickupResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

export function chunkAvailabilityPayloadsArray(
  array: BulkAvailabilityPayload[],
  chunkSize: number
) {
  const chunks: BulkAvailabilityPayload[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }

  return chunks;
}

const deliveryPickupNinetyNinthPercentile = 2200;

export default function useChunkedBulkAvailability() {
  const { zip } = useUserLocation();
  const { clientId } = useContext(StaticContext);

  return useCallback(
    async (
      controller: AbortController,
      payloadSets: BulkAvailabilityPayload[][]
    ) => {
      const fetchPromises = payloadSets.map(chunk =>
        httpWithAuth
          .post<DeliveryPickupResponse>(
            GET_DELIVERY_PICKUP,
            {
              vehicles: chunk,
              zipCode: zip
            },
            {
              headers: {
                browsercookieid: BrowserCookies.get('BrowserCookieId') ?? '',
                clientid: clientId,
                correlationId: ''
              },
              timeout: deliveryPickupNinetyNinthPercentile,
              signal: controller.signal
            }
          )
          .then(({ data }) => data)
      );

      return Promise.all(fetchPromises);
    },
    [clientId, zip]
  );
}
